module.exports = __webpack_public_path__ + "static/img/品牌特权.e6b19173.png";